module.exports = __webpack_public_path__ + "assets/d1d1a8ff5fd58a7e91a72fa8691f1d04.mp3";